import { type ReactElement } from 'react'

import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'

/**
 * Placeholder for one labelled form control. The 4px gap and the 48px block mirror `Field.Root`'s
 * own gap and the `large` input height, so the pending form lines up with the resolved one.
 */
export function FieldSkeleton(): ReactElement {
  return (
    <div className="flex flex-col gap-20">
      <Skeleton variant="text" width={140} height={20} />
      <Skeleton variant="block" height={48} />
    </div>
  )
}
